module.exports = __webpack_public_path__ + "static/media/selfieIlustration.cb2650e8.png";